import { render } from "./Button.vue?vue&type=template&id=5f1374c6&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import "./Button.vue?vue&type=style&index=0&id=5f1374c6&scoped=true&lang=css"

import exportComponent from "C:\\VueJs\\odeveloper\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f1374c6"]])

export default __exports__